import { IMethod, IRequestParams, IResponse } from '@dash/apiInstance';
import { all, call, put, takeEvery } from 'redux-saga/effects';
import { sendRequest } from 'src/helpers/saga';
import { t } from 'src/i18n';
import { executeAction } from 'src/helpers/api';
import { logger } from 'src/helpers/logger';
import notifications from '../../../../../redux/notifications/actions';
import actionTypes from './actionTypes';
import { ProcessActionRequestAction } from './actions.d';
import { IProcessActionResponse } from './types.d';
import actions from './actions';
import skillsActions from '../actions';

function* processAction({ payload }: ProcessActionRequestAction<{}, {}>) {
  try {
    const { url, method, data, key, id } = payload;

    const params: { url?: string; method?: IMethod; data?: any } = { url, method };

    if (method?.toLowerCase() !== 'get') {
      params.data = data;
    }

    const result: IResponse<IProcessActionResponse> = yield call<any, IRequestParams<{}, {}>, string>(
      sendRequest,
      executeAction,
      params,
      notifications.REQUEST_ERROR,
    );

    if (result?.status === 200) {
      if (key === 'mark_as_active_form_data') {
        yield put(
          actions.loadFormInfoSuccess({
            // @ts-ignore
            formInfo: result.data?.success?.data,
          }),
        );
      } else if (key === 'mark_as_active') {
        yield put(
          notifications.addNotification({
            headline: t('dash.common.notification.success_headline'),
            type: 'success',
            message: t('dash.clients.components.enableSkillModal.success_headline'),
          }),
        );

        yield put(skillsActions.loadActiveSkillsRequest({ id }));
        yield put(skillsActions.loadDeniedSkillsRequest({ id }));
        yield put(actions.changeModalVisibility({}));
      } else {
        yield put(
          notifications.addNotification({
            headline: t('dash.common.notification.success_headline'),
            type: 'success',
            message: result?.messages?.join(' ') || '',
          }),
        );
      }
    } else {
      yield put(
        notifications.addNotification({
          headline: t('dash.common.notification.error_headline'),
          type: 'error',
          message: t('dash.common.notification.something_went_wrong'),
        }),
      );
    }

    yield put({ type: actionTypes.PROCESS_ACTION_ERROR });
  } catch (error) {
    logger.error(error);
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actionTypes.PROCESS_ACTION_REQUEST, processAction)]);
}
